import { CustomPage as CustomPageState } from "../../../../publicSite/publicSite.module"
import { initOverviewWidget, OverviewState } from "../widgets/overviewWidget.state"
import { newsOverviewPageWidget } from "./newsOverviewPage.widget"

export type NewsOverviewPageState = {
    overviewState: OverviewState
} & CustomPageState

export const newsOverviewPageState = (): NewsOverviewPageState => ({
    widget: newsOverviewPageWidget,
    overviewState: initOverviewWidget(true, "news")
})